import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/approval-request-flows', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/approval-request-flows', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/approval-request-flows/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const enable = (id, data) => {
  return httpClient
    .put(`/api/v1/approval-request-flows/${id}/enable`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getMobileRole = (Options = {}) => {
  return httpClient
    .get('/api/v1/approval-request-flows/mobile-roles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getUser = (Options = {}) => {
  return httpClient
    .get('/api/v1/approval-request-flows/users', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getApprovalType = (Options = {}) => {
  return httpClient
    .get('/api/v1/approval-request-flows/approval-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getParameters = (Options = {}) => {
  return httpClient
    .get('/api/v1/approval-request-flows/get-params', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getApproverType = (Options = {}) => {
  return httpClient
    .get('/api/v1/approval-request-flows/approver-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getJobTitle = (Option = {}) => {
    return httpClient
      .get("/api/v1/approval-request-flows/job-title", Option)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data));
};

export default {
  get,
  store,
  update,
  getUser,
  getMobileRole,
  getApprovalType,
  enable,
  getParameters,
  getApproverType,
  getJobTitle
}
